import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["id", "disabled", "placeholder", "required", "maxlength", "minlength"];
const _hoisted_2 = ["title"];
const _hoisted_3 = ["title"];
const _hoisted_4 = ["title"];
const _hoisted_5 = ["title"];
const _hoisted_6 = {
    key: 0,
    class: "alert alert--warning"
};
import { ref, nextTick } from "vue";
import { useRoute } from "vue-router";
import log from "../../services/Logger";
import Icon from "../Icon.vue";
import secretsRepository from "../../services/SecretsRepository";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlSecret',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const route = useRoute();
        const model = ref(null);
        const input = ref(null);
        const fieldOptions = props.field.options || {};
        const edit = ref(false);
        const changed = ref(false);
        function save() {
            const app = route.params['app'] + '';
            secretsRepository
                .saveSecret(app, {
                secretId: props.data?.secretId,
                update: model.value || undefined,
            })
                .then(secret => {
                emitChange(secret);
                toggleEdit();
            });
        }
        function toggleEdit() {
            edit.value = !edit.value;
            changed.value = false;
            if (edit.value) {
                nextTick(() => {
                    input.value?.focus();
                });
            }
        }
        function emitChange(value) {
            log('FieldControlSecret@change', props.field.name, value);
            emit('change', value);
        }
        function onChange() {
            changed.value = true;
        }
        function onFocus() {
            emit('focus');
        }
        function onBlur() {
            emit('blur');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["form__control form__control--secret", { 'form__control--empty': !model.value, 'form__control--secret-edit': edit.value }])
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(["secret", { 'secret--changed': changed.value }])
                }, [
                    (edit.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((model).value = $event)),
                                onFocus: onFocus,
                                onBlur: onBlur,
                                onKeyup: onChange,
                                ref_key: "input",
                                ref: input,
                                type: "text",
                                id: __props.fieldId,
                                disabled: _unref(fieldOptions).disabled ?? undefined,
                                placeholder: _unref(fieldOptions).placeholder ?? undefined,
                                required: _unref(fieldOptions).required ?? undefined,
                                maxlength: _unref(fieldOptions).maxLength ?? undefined,
                                minlength: _unref(fieldOptions).minLength ?? undefined,
                                rows: 1,
                                autocomplete: "off",
                                "data-1p-ignore": "",
                                class: "secret__input"
                            }, null, 40, _hoisted_1), [
                                [_vModelText, model.value]
                            ]),
                            _cache[5] || (_cache[5] = _createTextVNode()),
                            _createElementVNode("a", {
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (save()), ["prevent"])),
                                href: "",
                                class: "secret__action",
                                title: _ctx.$t('save')
                            }, [
                                _createVNode(Icon, {
                                    name: "save",
                                    class: "secret__icon",
                                    "icon-style": changed.value ? 'solid' : 'regular'
                                }, null, 8, ["icon-style"])
                            ], 8, _hoisted_2),
                            _cache[6] || (_cache[6] = _createTextVNode()),
                            _createElementVNode("a", {
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (toggleEdit()), ["prevent"])),
                                href: "",
                                class: "secret__action",
                                title: _ctx.$t('cancel')
                            }, [
                                _createVNode(Icon, {
                                    name: "cancel",
                                    class: "secret__icon"
                                })
                            ], 8, _hoisted_3)
                        ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("span", {
                                class: "secret__value",
                                onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (toggleEdit()), ["prevent"])),
                                title: _ctx.$t('edit')
                            }, [
                                _createVNode(Icon, {
                                    name: "shield-alt",
                                    class: "secret__icon"
                                }),
                                _createTextVNode(" " + _toDisplayString(__props.data?.maskedValue || '******'), 1)
                            ], 8, _hoisted_4),
                            _cache[7] || (_cache[7] = _createTextVNode()),
                            _createElementVNode("a", {
                                onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (toggleEdit()), ["prevent"])),
                                href: "",
                                class: "secret__action",
                                title: _ctx.$t('edit')
                            }, [
                                _createVNode(Icon, {
                                    name: "edit",
                                    class: "secret__icon"
                                })
                            ], 8, _hoisted_5)
                        ], 64))
                ], 2),
                _cache[8] || (_cache[8] = _createTextVNode()),
                (changed.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(Icon, { name: "info" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('form_field_secret_unsaved')), 1)
                    ]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
